import Vue from 'vue'
import {
  Pagination,// 分页
  Dialog,//对话框
  // Autocomplete,//×
  Dropdown,//下拉菜单×
  DropdownMenu,//下拉
  DropdownItem,//下拉
  Menu,//导航菜单
  Submenu,
  MenuItem,
  MenuItemGroup,
  Input,//输入框
  InputNumber,
  Radio,//单选框
  RadioGroup,
  RadioButton,
  Checkbox,//多选框
  CheckboxButton,
  CheckboxGroup,
  Switch,//开关
  Select,//选择器
  Option,//选择
  OptionGroup,
  Button,//按钮
  ButtonGroup,
  Table,//表格
  TableColumn,
  DatePicker,//日期
  TimeSelect,//时间
  TimePicker,
  Popover,//弹出框
  Tooltip,//文字提示
  Breadcrumb,//面包屑
  BreadcrumbItem,
  Form,//表单
  FormItem,
  Tabs,//标签页
  TabPane,
  Tag,//标签
  Tree,//树形控件
  Alert,//警告
  Slider,//滑块
  Icon,//图标
  Row,//行
  Col,//列
  Upload,//上传
  Progress,//进度条
  // Spinner,//
  Badge,//标记
  Card,//卡片
  // Rate,//评分
  Steps,//步骤
  Step,
  // Carousel,//走马灯
  // CarouselItem,
  Collapse,//折叠面板
  CollapseItem,
  Cascader,//级联选择器
  ColorPicker,//颜色选择器
  // Transfer,//穿梭框
  Container,//布局容器
  Header,//顶部
  Aside,//侧边
  Main,//内容区
  Footer,//底部
  Timeline,//时间线
  TimelineItem,
  Link,//链接
  // Divider,//分割线
  Image,//图片
  // Calendar,//日历
  // Backtop,//回到顶部
  // PageHeader,//页头
  CascaderPanel,//级联
  Loading,//加载
  MessageBox,//弹框
  Message,//消息提示
  Notification,
  Descriptions,//描述列表
  DescriptionsItem,
  Drawer,//抽屉
} from 'element-ui'
Vue.use(Pagination)
Vue.use(Dialog)
// Vue.use(Autocomplete)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Alert)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
Vue.use(Progress)
// Vue.use(Spinner)
Vue.use(Badge)
Vue.use(Card)
// Vue.use(Rate)
Vue.use(Steps)
Vue.use(Step)
// Vue.use(Carousel)
// Vue.use(CarouselItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Cascader)
Vue.use(ColorPicker)
// Vue.use(Transfer)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Link)
// Vue.use(Divider)
Vue.use(Image)
// Vue.use(Calendar)
// Vue.use(Backtop)
// Vue.use(PageHeader)
Vue.use(CascaderPanel)
//描述列表
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Drawer)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message